import { Link } from 'gatsby';
import "../../../../src/pages/design/design-guidelines-styles.css";
import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import { Button } from 'react-magma-dom';
import * as React from 'react';
export default {
  Link,
  LeadParagraph,
  Button,
  React
};